/* Campus Products theme JS — no dependencies */
(function () {
  'use strict';

  /* Mobile nav toggle */
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Product media gallery (images + video) */
  document.querySelectorAll('[data-media-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-media-id');
      document.querySelectorAll('.product-media').forEach(function (m) {
        var active = m.getAttribute('data-media-id') === id;
        m.classList.toggle('is-active', active);
        if (!active) {
          var vid = m.querySelector('video');
          if (vid) vid.pause();
        }
      });
      document.querySelectorAll('[data-media-thumb]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
      });
      btn.setAttribute('aria-pressed', 'true');
    });
  });

  /* Quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
        if (input.form && input.closest('.cart-table')) input.form.submit();
      });
    });
  });

  /* Variant selection — swap selected variant id, price, availability */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var dataEl = document.getElementById('ProductVariants');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = productForm.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = productForm.querySelector('[data-add-to-cart]');

    function currentOptions() {
      var opts = [];
      productForm.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateVariant() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = '';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<s>' + money(match.compare_at_price) + '</s>';
        }
        html += money(match.price);
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-soldout');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    productForm.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });
    if (variants.length) updateVariant();
  }
})();
